import { Box, BoxProps, GridProps, styled } from '@mui/material';

export const SnackbarContainer = styled(Box)<BoxProps & GridProps>(({ theme }) => ({
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    width: '350px',
    minHeight: '120px',
    borderRadius: '12px',
    backgroundColor: theme.palette.background.default,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    zIndex: 1500
}));
